import {
  ChangeDetectionStrategy,
  Component,
  Inject,
}                                from '@angular/core';
import { MAT_DIALOG_DATA }       from '@angular/material/dialog';
import {
  fileIcon,
  needsBrandColor,
}                                from '~domain/enums';
import { RbDocument }            from '~domain/types';
import {
  DialogButton,
  DialogConfig,
}                                from '~shared/components';
import { DeleteDocumentService } from './delete-document.service';

export type DeleteDocumentRequest = {
  documents: RbDocument[],
};

@Component({
  selector: 'rb-delete-document-dialog',
  templateUrl: './delete-document-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DeleteDocumentDialogComponent {
  deleteDocumentIsLoading$ = this.deleteDocumentService.deleteDocumentIsLoading$;

  dialogConfig: DialogConfig = {
    title: `APP.DOCUMENT.DELETE_DOCUMENT.DIALOG.TITLE${this.translationKeySuffix}`,
    closeable: true,
    compact: true,
    buttons: [
      {
        id: DialogButton.Cancel,
        label: 'APP.BUTTON.CANCEL.LABEL',
        icon: 'cross',
        style: 'secondary',
      },
      {
        id: DialogButton.OK,
        label: 'APP.BUTTON.DELETE.LABEL',
        icon: 'delete',
        style: 'negative',
        autoClose: false,
        isLoading$: this.deleteDocumentIsLoading$,
      },
    ],
  };

  protected readonly needsBrandColor = needsBrandColor;
  protected readonly fileIcon = fileIcon;

  constructor(
    @Inject(MAT_DIALOG_DATA) public request: DeleteDocumentRequest,
    private readonly deleteDocumentService: DeleteDocumentService,
  ) {
  }

  get translationKeySuffix() {
    return this.request.documents.length === 1 ? '_SINGLE' : '_MULTI';
  }

  onDialogButtonClick(dialogButton: DialogButton) {
    if (dialogButton === DialogButton.OK) {
      this.deleteDocumentService.deleteDocuments(this.request.documents.map(d => d.id));
    }

    if (dialogButton === DialogButton.Cancel) {
      this.deleteDocumentService.reloadPage();
    }
  }
}
